import { FieldOption, FilterGroup, FilterInput } from '../constants';
import {
  hasWildcardChars,
  isIdentChipQuickSearchField,
  legacyFilterToChipValue,
} from './animalIdentChipFilter';

/** AI may emit legacy column fields; the advanced UI uses composite chip fields. */
const AI_COMPOSITE_FIELD_ALIASES: Record<string, string> = {
  ANIMAL_NAME: FieldOption.searchTerm.value,
  ANIMAL_IDENT: FieldOption.searchTerm.value,
  MEMB_NAME: FieldOption.member.value,
  MEMBER_IDENT: FieldOption.member.value,
  MEMBER_NAME: FieldOption.member.value,
};

function resolveAiField(field: string): string {
  const trimmed = field.trim();
  const upper = trimmed.toUpperCase();
  return AI_COMPOSITE_FIELD_ALIASES[upper] ?? trimmed;
}

function shouldUseChipInput(field: string, originalField: string): boolean {
  const originalUpper = originalField.trim().toUpperCase();
  return (
    isIdentChipQuickSearchField(field) ||
    originalUpper === FieldOption.animalName.value ||
    originalUpper === FieldOption.animalIdent.value
  );
}

/**
 * Maps AI filter JSON into the shape the advanced filter UI expects (composite
 * ANIMAL chip rows instead of ANIMAL_NAME + operator + value triples).
 */
export function normalizeAiSearchFilter(filter: FilterInput): FilterInput {
  const originalField = filter.field ?? '';
  const field = resolveAiField(originalField);

  if (shouldUseChipInput(field, originalField)) {
    const rawValue = filter.value ?? '';
    const value =
      filter.operator && !hasWildcardChars(rawValue)
        ? legacyFilterToChipValue(filter.operator, rawValue)
        : rawValue;
    return { field, operator: '', value };
  }

  return { ...filter, field };
}

export function normalizeAiSearchFilterGroups(
  filterGroups: FilterGroup[],
): FilterGroup[] {
  return filterGroups.map((group) => ({
    ...group,
    filters: group.filters.map(normalizeAiSearchFilter),
  }));
}
